export const SET_TOKENS = 'SET_TOKENS';

export const setTokens = (accessToken, refreshToken) => ({
    type: SET_TOKENS,
    payload: {
        accessToken,
        refreshToken
    }
});
